/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Flex, Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import Spreadsheet from 'react-spreadsheet';
import { isNullOrBlank } from '../../../utils/checker';
import { calculateORDRatioCells } from '../../../utils/ews-ord-utils';
import { toFormatCurrency } from '../../../utils/format';
import { checkSelectedActiveColumn } from '../../../utils/market-development';
import { makeBoldCells } from '../utils';
import EWSLabels from './ews-template-labels';

export default function EWSORDRATIO({ readOnly = false, code = null, labels = [], cells = [], onChange = ({ code, cells }) => null }) {
	const { t } = useTranslation();
	const location = useLocation();
	const urlParams = new URLSearchParams(location.search);
	const year = urlParams.get('year') || null;
	const [dataCells, setDataCells] = useState([]);
	const [active, setActive] = useState(null);

	useEffect(() => {
		setDataCells(
			makeBoldCells(
				labels,
				(cells || [])?.map((row, rowIndex) => {
					return row?.map((cell, colIndex) => {
						return {
							...cell,
							value: (function () {
								if (false === isNullOrBlank(cell?.value)) {
									return toFormatCurrency(cell?.value);
								}
								return cell?.value;
							})(),
						};
					});
				}),
			),
		);
	}, [cells]);

	return (
		<>
			<Box>
				<Text fontSize="large" fontWeight="bold" mb={4}>
					{t('Other Required Disclosures')}
				</Text>
				<Box className="ews-container">
					<div className="ews-1-row-head-data" />
					<table className="spreadsheet_custom_header">
						<thead>
							<tr style={{ height: '50px' }}>
								<>
									<th
										className={checkSelectedActiveColumn(active, 0) ? 'active-column' : 'ews-background-light-silver'}
										style={{ textAlign: 'center' }}
									>
										{year}
									</th>
									<th
										className={checkSelectedActiveColumn(active, 1) ? 'active-column' : 'ews-background-light-silver'}
										style={{ textAlign: 'center' }}
									>
										{year - 1}
									</th>
									<th
										className={checkSelectedActiveColumn(active, 2) ? 'active-column' : 'ews-background-light-silver'}
										style={{ textAlign: 'center' }}
									>
										{year - 2}
									</th>
								</>
							</tr>
							<tr style={{ height: '34px' }}>
								<td className={checkSelectedActiveColumn(active, 0) ? 'active-column' : 'ews-background-light-silver'}>{t('USD')}</td>
								<td className={checkSelectedActiveColumn(active, 1) ? 'active-column' : 'ews-background-light-silver'}>{t('USD')}</td>
								<td className={checkSelectedActiveColumn(active, 2) ? 'active-column' : 'ews-background-light-silver'}>{t('USD')}</td>
							</tr>
						</thead>
					</table>

					<div>
						<EWSLabels type="EWS" labels={labels} active={active} />
						<Box>
							<Flex alignItems="center" mt="0px" h="0px" borderRight="1px solid hsl(2deg, 0%, 91%)" pl={2} pr={2} />
							<Spreadsheet
								data={dataCells}
								onChange={(dataCells) => {
									if (readOnly) {
										onChange({
											code,
											cells: cells?.reduce((pre, cur, i) => {
												let localPre = pre;
												localPre.push([
													{ value: cur[0]?.value, readOnly: true },
													{ value: cur[1]?.value, readOnly: true },
													{ value: cur[2]?.value, readOnly: true },
												]);
												return localPre;
											}, []),
										});
									} else {
										onChange(calculateORDRatioCells({ code, cells: dataCells, numLabel: labels?.length }));
									}
								}}
								onActivate={(e) => setActive({ ...e, t: 'EWS' })}
								hideRowIndicators
								hideColumnIndicators
							/>
						</Box>
					</div>
				</Box>
			</Box>
		</>
	);
}
